import { all, call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchParkedVisitsAPI } from '../../../services/group-admin-service';
import { FETCH_PARKED_VISITS, FETCH_PARKED_VISITS_ERROR, FETCH_PARKED_VISITS_START, FETCH_PARKED_VISITS_SUCCESS, SET_PARKED_VISITS_PAGINATION } from '../../actions/groupadmin/parkedActions';

function* fetchGroupAdminParkedVisits({ payload }) {
    try {
        yield put({ type: FETCH_PARKED_VISITS_START })
        let response = yield call(fetchParkedVisitsAPI, payload);
        if (response.data) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_PARKED_VISITS_SUCCESS, parked: response.data.parked })
            yield put({ type: SET_PARKED_VISITS_PAGINATION, pagination });
        } else {
            yield put({ type: FETCH_PARKED_VISITS_ERROR });
            message.error('Failed to fetch parked visits!');
        }

    } catch (error) {
        message.error('Failed to fetch parked visits!');
        yield put({ type: FETCH_PARKED_VISITS_ERROR, error })
    }

}

function* fetchGroupAdminParkedWatcher() {
    yield takeLatest(FETCH_PARKED_VISITS, fetchGroupAdminParkedVisits)
}

export default function* rootSaga() {
    yield all([
        fetchGroupAdminParkedWatcher()
    ]);
}